import React, { Component } from "react";
import StepperPage from "./StepperPage";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import axios from "../../../AxiosClient";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import { Dropbox } from "dropbox";
import { documentLimitReached } from "../../../utils/LicenceUtils";
import "../../../sa-icons.css";

const redirect = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}/oauth2/redirect`;
export class AuthorisationPage extends Component {
  state = {
    hasAuth: false,
    authError: false,
    googleDomainDialogOpen: false,
  };

  componentDidMount() {
    if (
      !document.querySelector(
        "script[src='https://apis.google.com/js/api.js?onload=onGapiLoad']"
      )
    ) {
      const gapiScript = document.createElement("script");
      gapiScript.src = "https://apis.google.com/js/api.js?onload=onGapiLoad";
      window.onGapiLoad = function onGapiLoad() {
        window.gapi.load("auth2", () => {});
      };
      document.body.appendChild(gapiScript);
    }
    if (!this.props.isDryRun) {
      this.props.setReindexDisabled(true);
    }
  }

  getHeaderText = () => {
    if (this.state.authError) {
      return <Trans i18nKey="authorisation_error" />;
    }
    if (this.state.hasAuth) {
      return <Trans i18nKey="authorisation_successful" />;
    }
    return <Trans i18nKey="authorisation_required" />;
  };

  getBodyText = () => {
    if (this.state.hasAuth) {
      return <Trans i18nKey="create_ks_authorisation_success" />;
    }
    if (this.state.authError) {
      return <Trans i18nKey="create_ks_authorise_error" />;
    }
    if (this.props.isDryRun) {
      return <Trans i18nKey="create_ks_dry_run_authorise" />;
    }
    if (this.props.isReindex) {
      return <Trans i18nKey="reindex_ks_authorisation_required" />;
    }
    return (
      <Trans
        i18nKey="create_ks_added_needs_authorisation"
        values={{ description: this.props.description }}
      />
    );
  };

  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <>
          {this.state.authError ? (
            <div class="sa">
              <div class="sa-error">
                <div class="sa-error-x">
                  <div class="sa-error-left" />
                  <div class="sa-error-right" />
                </div>
                <div class="sa-error-placeholder" />
                <div class="sa-error-fix" />
              </div>
            </div>
          ) : (
            <>
              {this.state.hasAuth ? (
                <div class="sa">
                  <div class="sa-success">
                    <div class="sa-success-tip" />
                    <div class="sa-success-long" />
                    <div class="sa-success-placeholder" />
                    <div class="sa-success-fix" />
                  </div>
                </div>
              ) : (
                <div class="sa">
                  <div
                    class={`sa-warning ${
                      this.props.isDryRun ? "" : "sa-warning-pulse"
                    }`}
                  >
                    <div
                      class={`sa-warning-body ${
                        this.props.isDryRun ? "" : "sa-warning-body-pulse"
                      }`}
                    />
                    <div
                      class={`sa-warning-dot ${
                        this.props.isDryRun ? "" : "sa-warning-dot-pulse"
                      }`}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
        <Typography variant="h4" style={{ marginBottom: 30 }}>
          {this.getHeaderText()}
        </Typography>
        <Typography>{this.getBodyText()}</Typography>
        {!this.state.authError &&
          !this.state.hasAuth && (
            <Typography>
              <Trans i18nKey="create_ks_click_button_authorise" />
            </Typography>
          )}
        {!this.state.hasAuth && (
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={this.doAuth}
            style={{ marginTop: 30 }}
          >
            <Trans i18nKey="global_authorise" />
          </Button>
        )}

        <Dialog
          open={this.state.googleDomainDialogOpen}
          onClose={() => this.setState({ googleDomainDialogOpen: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Google Drive domain authentication
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              To allow the Service Account to access your Google Workspace data,
              you must delegate domain-wide authority to the account. Steps to
              do this can be found in{" "}
              <a
                target="_blank"
                href="https://support.google.com/a/answer/162106?hl=en#zippy=%2Cset-up-domain-wide-delegation-for-a-client"
              >
                Google's guide for domain-wide delegation
              </a>. Once this has been done, click "Continue" below.
              <br />
              <br /> You will need to provide the following information:<br />
              <br />
              <b>Client ID:</b> <code>101771233951846815809</code>
              <br />
              <b>Scopes:</b>{" "}
              <code>
                https://www.googleapis.com/auth/drive.metadata.readonly
                https://www.googleapis.com/auth/drive.readonly
              </code>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ googleDomainDialogOpen: false })}
              color="primary"
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              onClick={() => this.props.onAuth()}
              color="primary"
              autoFocus
            >
              <Trans i18nKey="global_continue" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  doAuth = () => {
    switch (this.props.sourceType) {
      case "GOOGLE_DRIVE":
        if (this.props.authOnDomain) {
          this.setState({ googleDomainDialogOpen: true });
        } else {
          this.authGoogleDrive();
        }
        break;
      case "DROPBOX":
        if (this.props.authOnDomain) {
          this.authDropboxDomain();
        } else {
          this.authDropbox();
        }
        break;
      case "SALESFORCE":
        this.authSalesforce();
        break;
      case "SHAREPOINT":
        if (this.props.authOnDomain) {
          this.authGraphDomain();
        } else {
          this.authGraph();
        }
      case "ONEDRIVE":
        if (this.props.authOnDomain) {
          this.authGraphDomain();
        } else {
          this.authGraph();
        }
        break;
      default:
        break;
    }
  };

  authSalesforce = () => {
    let authUrl =
      "https://login.salesforce.com/services/oauth2/authorize" +
      "?response_type=code" +
      "&client_id=" +
      this.props.clientId +
      "&redirect_uri=" +
      redirect;
    this.openPopup(
      authUrl,
      (location) => {
        // success
        let url = new URL(location);
        if (this.props.isDryRun) {
          this.props.onAuth(url.searchParams.get("code"));
        } else {
          axios
            .post(
              `/knowledgesource/${
                this.props.knowledgeSourceId
              }/salesforce/authorise`,
              {
                authorisationCode: url.searchParams.get("code"),
              }
            )
            .then(() => {
              this.setState({ hasAuth: true, authError: false });
              if (!documentLimitReached()) {
                this.props.setReindexDisabled(false);
              }
              if (this.props.isReindex) {
                this.props.onAuth();
              }
            })
            .catch(() => {
              this.setState({ authError: true });
            });
        }
      },
      () => {
        // error
        this.setState({ authError: true });
      }
    );
  };

  authDropbox = () => {
    let dbx = new Dropbox({
      clientId: this.props.clientId,
    });
    let authUrl = dbx.getAuthenticationUrl(redirect, "", "code");
    this.openPopup(
      authUrl,
      (location) => {
        // success
        let url = new URL(location);
        if (this.props.isDryRun) {
          this.props.onAuth(url.searchParams.get("code"));
        } else {
          axios
            .post(
              `/knowledgesource/${
                this.props.knowledgeSourceId
              }/dropbox/authorise`,
              {
                authorisationCode: url.searchParams.get("code"),
                redirect: redirect,
              }
            )
            .then(() => {
              this.setState({ hasAuth: true, authError: false });
              if (!documentLimitReached()) {
                this.props.setReindexDisabled(false);
              }
              if (this.props.isReindex) {
                this.props.onAuth();
              }
            })
            .catch(() => {
              this.setState({ authError: true });
            });
        }
      },
      () => {
        this.setState({ authError: true });
      }
    );
  };

  authDropboxDomain = () => {
    let dbx = new Dropbox({
      clientId: this.props.clientId,
    });
    let authUrl = dbx.getAuthenticationUrl(redirect, "", "code");
    this.openPopup(
      authUrl,
      (location) => {
        // success
        let url = new URL(location);
        if (this.props.isDryRun) {
          this.props.onAuth(url.searchParams.get("code"));
        } else {
          axios
            .post(
              `/knowledgesource/${
                this.props.knowledgeSourceId
              }/dropbox/authorise`,
              {
                authorisationCode: url.searchParams.get("code"),
                redirect: redirect,
              }
            )
            .then(() => {
              this.setState({ hasAuth: true, authError: false });
              if (!documentLimitReached()) {
                this.props.setReindexDisabled(false);
              }
              if (this.props.isReindex) {
                this.props.onAuth();
              }
            })
            .catch(() => {
              this.setState({ authError: true });
            });
        }
      },
      () => {
        this.setState({ authError: true });
      }
    );
  };

  authGoogleDrive = () => {
    this.openPopup(
      "https://accounts.google.com/o/oauth2/auth" +
        "?client_id=" +
        this.props.clientId +
        "&response_type=code" +
        "&redirect_uri=" +
        redirect +
        "&prompt=consent" +
        "&access_type=offline" +
        "&scope=https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive.readonly",
      (location) => {
        // success
        let url = new URL(location);
        if (this.props.isDryRun) {
          this.props.onAuth(url.searchParams.get("code"));
        } else {
          axios
            .post(
              `/knowledgesource/${
                this.props.knowledgeSourceId
              }/google/authorise`,
              {
                redirect: redirect,
                authorisationCode: url.searchParams.get("code"),
              }
            )
            .then(() => {
              this.setState({ hasAuth: true, authError: false });
              if (!documentLimitReached()) {
                this.props.setReindexDisabled(false);
              }
              if (this.props.isReindex) {
                this.props.onAuth();
              }
            })
            .catch(() => {
              this.setState({ authError: true });
            });
        }
      }
    );

    // window.gapi.auth2.authorize(
    //   {
    //     clientId: this.props.clientId,
    //     scope:
    //       "https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive.readonly",
    //     response_type: "code",
    //     access_type: "offline",
    //     prompt: "consent",
    //     redirect_uri: redirect,
    //   },
    //   (res) => {
    //     if (res.error) {
    //       this.setState({ authError: true });
    //       return;
    //     }
    //     if (this.props.isDryRun) {
    //       this.props.onAuth(res.code);
    //     } else {
    //       axios
    //         .post(
    //           `/knowledgesource/${
    //             this.props.knowledgeSourceId
    //           }/google/authorise`,
    //           {
    //             authorisationCode: res.code,
    //           }
    //         )
    //         .then(() => {
    //           this.setState({ hasAuth: true, authError: false });
    //           if (!documentLimitReached()) {
    //             this.props.setReindexDisabled(false);
    //           }
    //           if (this.props.isReindex) {
    //             this.props.onAuth();
    //           }
    //         })
    //         .catch(() => {
    //           this.setState({ authError: true });
    //         });
    //     }
    //   }
    // );
  };

  authGoogleDriveDomain = () => {
    //TODO: Popup that tells user how to auth for domain
  };

  authGraph = () => {
    this.openPopup(
      "https://login.microsoftonline.com/" +
        "common/oauth2/v2.0/authorize" +
        "?client_id=" +
        this.props.clientId +
        "&response_type=code" +
        "&redirect_uri=" +
        redirect +
        "&prompt=consent" +
        "&response_mode=query" +
        "&scope=https://graph.microsoft.com/Files.Read.All https://graph.microsoft.com/Sites.Read.All https://graph.microsoft.com/User.Read https://graph.microsoft.com/offline_access",
      (location) => {
        // success
        let url = new URL(location);
        if (this.props.isDryRun) {
          this.props.onAuth(url.searchParams.get("code"));
        } else {
          axios
            .post(
              `/knowledgesource/${
                this.props.knowledgeSourceId
              }/sharepoint/authorise`,
              {
                authorisationCode: url.searchParams.get("code"),
                redirect: redirect,
              }
            )
            .then(() => {
              this.setState({ hasAuth: true, authError: false });
              if (!documentLimitReached()) {
                this.props.setReindexDisabled(false);
              }
              if (this.props.isReindex) {
                this.props.onAuth();
              }
            })
            .catch(() => {
              this.setState({ authError: true });
            });
        }
      },
      () => {
        this.setState({ authError: true });
      }
    );
  };

  authGraphDomain = () => {
    this.openPopup(
      "https://login.microsoftonline.com/" +
        "common/adminconsent" +
        "?client_id=" +
        this.props.clientId +
        "&redirect_uri=" +
        redirect,
      () => {
        // success
        if (this.props.isDryRun) {
          return this.props.onAuth();
        }
        this.setState({ hasAuth: true, authError: false });
        if (!documentLimitReached()) {
          this.props.setReindexDisabled(false);
        }
        if (this.props.isReindex) {
          this.props.onAuth();
        }
      },
      () => {
        // error
        this.setState({ authError: true });
      }
    );
  };

  openPopup = (url, successCallback, errCallback, redirectUrl = redirect) => {
    let popUpWidth = 483;
    let popUpHeight = 600;
    let winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    let winTop = window.screenTop ? window.screenTop : window.screenY;
    let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    let height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    let left = width / 2 - popUpWidth / 2 + winLeft;
    let top_1 = height / 2 - popUpHeight / 2 + winTop;
    let popup = window.open(
      url,
      "",
      "width=" +
        popUpWidth +
        ", height=" +
        popUpHeight +
        ", top=" +
        top_1 +
        ", left=" +
        left
    );
    var pollTimer = window.setInterval(() => {
      if (popup && popup.closed) {
        window.clearInterval(pollTimer);
        errCallback();
      } else {
        try {
          var popUpWindowLocation = popup.location;
          if (popUpWindowLocation.href.indexOf(redirectUrl) !== -1) {
            window.clearInterval(pollTimer);
            popup.close();
            successCallback(popUpWindowLocation);
          }
        } catch (e) {
          // we will catch a cross origin error every time we try to access the popup until it redirects, ignore it
        }
      }
    }, 1);
  };
}

export default StepperPage(AuthorisationPage);
